import { useConfig } from "./use-config";

/**
 * Hook to check if the loyalty program is enabled for the salon.
 * Used for conditional rendering of tier-related UI elements.
 *
 * @returns boolean indicating if loyalty program features should be shown
 */
export function useLoyaltyProgram() {
  const { value: loyaltyProgramEnabled = true } = useConfig("loyalty.enabled");

  return loyaltyProgramEnabled;
}
